package com.arena_web.ui.utils

import kotlin.js.Date

object ChatTimeUtils {

    fun formatChatTime(iso: String): String {
        val date = Date(iso)
        val now = Date()

        return when {
            isSameDay(date, now) -> formatTime(date)
            isSameWeek(date, now) -> getShortDayName(date)
            else -> formatShortDate(date)
        }
    }

    fun formatMessageTime(iso: String): String {
        val date = Date(iso)
        return formatTime(date)
    }

    private fun formatTime(date: Date): String {
        val h = date.getHours().toString().padStart(2, '0')
        val m = date.getMinutes().toString().padStart(2, '0')
        return "$h:$m"
    }

    private fun formatShortDate(date: Date): String {
        val d = date.getDate().toString().padStart(2, '0')
        val m = (date.getMonth() + 1).toString().padStart(2, '0')
        return "$d/$m"
    }

    private fun getShortDayName(date: Date): String {
        val days = arrayOf("Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat")
        return days[date.getDay()]
    }

    private fun isSameDay(a: Date, b: Date): Boolean {
        return a.getFullYear() == b.getFullYear() &&
                a.getMonth() == b.getMonth() &&
                a.getDate() == b.getDate()
    }

    private fun isSameWeek(date: Date, now: Date): Boolean {
        val diffMs = now.getTime() - date.getTime()
        val diffDays = diffMs / (1000.0 * 60 * 60 * 24)
        return diffDays < 7
    }
}
